//Before Add Cache Clear Button--------------------------------------------------------------------------------------------

// import React, { useEffect, useState } from "react";
// import {
//   Avatar,
//   Box,
//   Drawer,
//   IconButton,
//   List,
//   ListItem,
//   ListItemAvatar,
//   ListItemText,
//   Typography,
//   Collapse,
// } from "@mui/material";
// import {
//   Assignment as AssignmentIcon,
//   CalendarToday as CalendarTodayIcon,
//   Close as CloseIcon,
//   ExitToApp as ExitToAppIcon,
//   History as HistoryIcon,
//   Home as HomeIcon,
//   WorkHistory as WorkHistoryIcon,
//   Work as Job,
//   MoreTime as OT,
//   ContentPaste as ContentPasteIcon,
//   Addchart as OverTime,
//   ExpandLess,
//   ExpandMore,
// } from "@mui/icons-material";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { fetchJobItems } from "../../actions/jobAction";
// import { fetchUserData } from "../../service/authService";
// import { fetchJobs } from "../../actions/AssignAction";
// import Logo from "../../assets/logo6.png";

// const Sidebar = ({ open, toggleDrawer }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const [phoneNumber, setPhoneNumber] = useState(localStorage.getItem("phoneNumber") || "");
//   const [employeeId, setEmployeeId] = useState(localStorage.getItem("employeeId") || "");
//   const [employeeName, setEmployeeName] = useState(localStorage.getItem("employeeName") || "");
//   const [department, setDepartment] = useState(localStorage.getItem("department") || "");
//   const [role, setRole] = useState(localStorage.getItem("role") || "");
//   const [userImg, setUserImg] = useState("");
//   const [openManagement, setOpenManagement] = useState(false);

//   // Redux store
//   const { jobValue } = useSelector((state) => state.assignJob || {});

//   // Update user image and fetch jobs
//   useEffect(() => {
//     if (employeeId) {
//       setUserImg(`https://esystems.cdl.lk/backend/AttendMe2/Home/GetDTSUserImg?serviceNo=${employeeId}`);
//       const date = new Date().toISOString().split("T")[0];
//       dispatch(fetchJobs(date, employeeId));
//     }
//   }, [employeeId]);

//   // Fetch user data if missing
//   useEffect(() => {
//     if (phoneNumber && !employeeId) {
//       const fetchUserDataAsync = async () => {
//         try {
//           const response = await fetchUserData(phoneNumber);
//           if (response?.responceType === true && response?.responceMessage) {
//             const [empId, empName, dept, role] = response.responceMessage.split("/");
//             setEmployeeId(empId);
//             setEmployeeName(empName);
//             setDepartment(dept);
//             setRole(role);

//             localStorage.setItem("employeeId", empId);
//             localStorage.setItem("employeeName", empName);
//             localStorage.setItem("department", dept);
//             localStorage.setItem("role", role);
//             localStorage.setItem("correctPhoneFormat", response.correctPhoneFormat);
//           }
//         } catch (error) {
//           console.error("Failed to fetch user data:", error);
//         }
//       };
//       fetchUserDataAsync();
//     }
//   }, [phoneNumber, employeeId]);

//   console.log("Employee ID value:", employeeId);

//   // OT Permission
//   const allowedOTUsers = ["3000158", "3000159", "3000694", "1004507", "3001230", "3000821", "0001809", "3000699", "3000104", "3000283"];
//   const isOTAllowed = allowedOTUsers.includes(String(employeeId));

//   // Base menu items
//   const baseMenuItems = [
//     ...(isOTAllowed ? [{ text: "Management Info", path: "/overTimeView", icon: <OverTime /> }] : []),
//     { text: "Home", path: "/home", icon: <HomeIcon /> },
//     { text: "Today Attendance", path: "/todayAttendance", icon: <CalendarTodayIcon /> },
//     { text: "Attendance Jobs History", path: "/jobHistory", icon: <HistoryIcon /> },
//     { text: "All Attendance Jobs History", path: "/jobHistoryAll", icon: <WorkHistoryIcon /> },
//     { text: "Job", path: "/qrJobScanner", icon: <Job /> },
//     { text: "Assign Jobs", path: "/assignJob", icon: <AssignmentIcon /> },
//   ];

//   // Conditional menu items
//   const menuItems = [
//     ...baseMenuItems,
//     ...(jobValue && jobValue.length > 0
//       ? [
//           { text: "Assign OT", path: "/assignOT", icon: <OT /> },
//           { text: "Holiday Assign OT", path: "/holidayOT", icon: <OT /> },
//           { text: "OT Details", path: "/otDetails", icon: <ContentPasteIcon /> },
//         ]
//       : []),
//     { text: "Log Out", path: "/logout", icon: <ExitToAppIcon /> },
//   ];

//   // Navigation handler
//   const handleNavigation = (path) => {
//     if (path === "/jobHistory" || path === "/jobHistoryAll") {
//       dispatch(fetchJobItems(new Date().toISOString().split("T")[0], employeeId, role));
//     }
//     if (path === "/logout") {
//       localStorage.clear();
//       navigate("/");
//     } else {
//       navigate(path, { state: { employeeId, department, role } });
//     }
//     toggleDrawer(false);
//   };

//   return (
//     <Drawer
//       open={open}
//       onClose={() => toggleDrawer(false)}
//       anchor="left"
//       sx={{
//         "& .MuiDrawer-paper": {
//           width: 280,
//           bgcolor: "transparent",
//           borderRight: "none",
//           transition: "transform 0.3s ease",
//           transform: open ? "translateX(0)" : "translateX(-100%)",
//           boxShadow: "0 0 15px rgba(0, 0, 0, 0.5)",
//           borderTopRightRadius: 40,
//           borderBottomRightRadius: 40,
//           backdropFilter: "blur(10px)",
//         },
//       }}
//     >
//       <Box sx={{ display: "flex", flexDirection: "column", height: "100%", px: 2, py: 3, color: "white" }}>
//         {/* Header */}
//         <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//           <img src={Logo} alt="Logo" style={{ height: 70, objectFit: "contain", borderRadius: "5px" }} />
//           <IconButton onClick={() => toggleDrawer(false)} sx={{ color: "white" }}>
//             <CloseIcon />
//           </IconButton>
//         </Box>

//         {/* User Info */}
//         <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 2, textAlign: "center", width: "100%" }}>
//           <Avatar
//             src={userImg || "https://esystems.cdl.lk/QRApp_BackEnd/userImages/user.png"}
//             onError={() => setUserImg("https://esystems.cdl.lk/QRApp_BackEnd/userImages/user.png")}
//             sx={{ width: 130, height: 130, mb: 2, border: "3px solid #ddd" }}
//           />
//           <Typography variant="h6" color="white" sx={{ fontWeight: "bold" }}>
//             {employeeName || "Loading..."}
//           </Typography>
//           <Typography variant="body2" sx={{ color: "#E0A300", mt: 1, fontWeight: "bold" }}>
//             {department} - {role}
//           </Typography>
//         </Box>

//         {/* Menu */}
//         <List sx={{ mt: 4 }}>
//           {menuItems.map((item) => {
//             if (item.text === "Management Info") {
//               return (
//                 <Box key={item.text}>
//                   <ListItem
//                     button
//                     onClick={() => setOpenManagement(!openManagement)}
//                     sx={{ my: 1, borderRadius: 2, color: "white", "&:hover": { backgroundColor: "#F2B807" } }}
//                   >
//                     <ListItemAvatar>
//                       <Avatar sx={{ backgroundColor: "transparent", color: "white" }}>{item.icon}</Avatar>
//                     </ListItemAvatar>
//                     <ListItemText primary={item.text} />
//                     {openManagement ? <ExpandLess /> : <ExpandMore />}
//                   </ListItem>
//                   <Collapse in={openManagement} timeout="auto" unmountOnExit>
//                     <List sx={{ pl: 6 }}>
//                       <ListItem
//                         button
//                         onClick={() => handleNavigation("/overTimeView")}
//                         sx={{ my: 0.5, borderRadius: 2, color: "white", transition: "all 0.3s ease", "&:hover": { backgroundColor: "#F2B807", transform: "scale(1.03)" } }}
//                       >
//                         <ListItemText primary="HR" />
//                       </ListItem>
//                       <ListItem
//                         button
//                         onClick={() => handleNavigation("/production")}
//                         sx={{ my: 0.5, borderRadius: 2, color: "white", transition: "all 0.3s ease", "&:hover": { backgroundColor: "#F2B807", transform: "scale(1.03)" } }}
//                       >
//                         <ListItemText primary="Production" />
//                       </ListItem>
//                     </List>
//                   </Collapse>
//                 </Box>
//               );
//             }

//             // Regular menu item
//             return (
//               <ListItem
//                 button
//                 key={item.text}
//                 onClick={() => handleNavigation(item.path)}
//                 sx={{
//                   my: 1,
//                   backgroundColor: item.path === window.location.pathname ? "#E0A300" : "transparent",
//                   color: "white",
//                   borderRadius: 2,
//                   fontWeight: "bold",
//                   fontSize: 18,
//                   transition: "all 0.3s ease",
//                   "&:hover": { backgroundColor: "#F2B807", transform: "scale(1.05)" },
//                 }}
//               >
//                 <ListItemAvatar>
//                   <Avatar sx={{ backgroundColor: "transparent", color: "white" }}>{item.icon}</Avatar>
//                 </ListItemAvatar>
//                 <ListItemText primary={item.text} />
//               </ListItem>
//             );
//           })}
//         </List>
//       </Box>
//     </Drawer>
//   );
// };

// export default Sidebar;

//-------------------------------------------------------------------------------------------------------------------------------

import React, { useEffect, useMemo, useState } from "react";
import {
  Avatar,
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  Collapse,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Badge,
  Snackbar,
  Alert,
} from "@mui/material";
import {
  Assignment as AssignmentIcon,
  CalendarToday as CalendarTodayIcon,
  Close as CloseIcon,
  ExitToApp as ExitToAppIcon,
  History as HistoryIcon,
  Home as HomeIcon,
  WorkHistory as WorkHistoryIcon,
  Work as Job,
  MoreTime as OT,
  ContentPaste as ContentPasteIcon,
  Addchart as OverTime,
  ExpandLess,
  ExpandMore,
  DeleteSweep as DeleteSweepIcon,
  NoteAdd as IWO,
  Cake as CakeIcon,
  EventAvailable as LeaveApprovalIcon,
  Factory as ProductionMonitorIcon,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchJobItems } from "../../actions/jobAction";
import { fetchUserData } from "../../service/authService";
import { fetchJobs } from "../../actions/AssignAction";
import { fetchEmployeeBirthdayList } from "../../actions/EventsAction";
import Logo from "../../assets/logo6.png";

const Sidebar = ({ open, toggleDrawer }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [phoneNumber, setPhoneNumber] = useState(localStorage.getItem("phoneNumber") || "");
  const [employeeId, setEmployeeId] = useState(localStorage.getItem("employeeId") || "");
  const [employeeName, setEmployeeName] = useState(localStorage.getItem("employeeName") || "");
  const [department, setDepartment] = useState(localStorage.getItem("department") || "");
  const [role, setRole] = useState(localStorage.getItem("role") || "");
  const [employeeCategory, setEmployeeCategory] = useState(localStorage.getItem("employeeCategory") || "");
  const [employeeSubCategory, setEmployeeSubCategory] = useState(localStorage.getItem("employeeSubCategory") || "");
  const [userImg, setUserImg] = useState("");
  const [openManagement, setOpenManagement] = useState(false);
  const [openProductionMonitor, setOpenProductionMonitor] = useState(false);
  const [openPreFab, setOpenPreFab] = useState(false); 
  const [openErection, setOpenErection] = useState(false); 
  const [clearCacheDialogOpen, setClearCacheDialogOpen] = useState(false);

  // Redux store
  const { jobValue } = useSelector((state) => state.assignJob || {});

  // Update user image and fetch jobs
  useEffect(() => {
    if (employeeId) {
      setUserImg(`https://esystems.cdl.lk/backend/AttendMe2/Home/GetDTSUserImg?serviceNo=${employeeId}`);
      const date = new Date().toISOString().split("T")[0];
      dispatch(fetchJobs(date, employeeId));
    }
  }, [employeeId]);

  // Fetch user data if missing
useEffect(() => {
    if (phoneNumber && !employeeId) {
      const fetchUserDataAsync = async () => {
        try {
          const response = await fetchUserData(phoneNumber);
          if (response?.responceType === true && response?.responceMessage) {
            // Login API format: "empId/empName/department/role/category"
            const parts = response.responceMessage.split("/").map((p) => (p ?? "").trim());
            const [empId, empName, dept, role, category, subCategory] = parts;
            setEmployeeId(empId);
            setEmployeeName(empName);
            setDepartment(dept);
            setRole(role);
            setEmployeeCategory(category || "");
            setEmployeeSubCategory(subCategory || "");

            localStorage.setItem("employeeId", empId);
            localStorage.setItem("employeeName", empName);
            localStorage.setItem("department", dept);
            localStorage.setItem("role", role);
            localStorage.setItem("employeeCategory", category || "");
            localStorage.setItem("employeeSubCategory", subCategory || "");
            localStorage.setItem("correctPhoneFormat", response.correctPhoneFormat);
          }
        } catch (error) {
          console.error("Failed to fetch user data:", error);
        }
      };
      fetchUserDataAsync();
    }
  }, [phoneNumber, employeeId]);

  console.log("Employee ID value:", employeeId);

  // Category access config — edit these arrays to change who sees what
  const MENU_ACCESS = {
    managementInfo: ["D", "E", "S"],
    iwoRequest: ["D", "E", "S"],
    leaveApproval: ["D", "E", "S"],
  };

  const MANAGEMENT_SUBMENU_ACCESS = {
    attendance: ["D", "E", "S"],
    employees: ["D", "E"],
    production: ["D", "E", "S"],
  };

const FULL_ACCESS_OVERRIDE_IDS = ["3001230", "3000807", "3000821", "3000309", "3000553", "3001180", "3000170", "3001087", "3001411", "3001413","3000701"];
  const isFullAccessOverride = FULL_ACCESS_OVERRIDE_IDS.includes(String(employeeId));

  // Events (Birthdays) menu — only visible to these service numbers
  const EVENTS_ACCESS_IDS = ["3001230", "3000821", "3001087", "3000309", "3001413", "3001411", "3000701"];
  const canSeeEvents = EVENTS_ACCESS_IDS.includes(String(employeeId));

  // Fetch birthday data for access users so we can show a "birthday today" reminder
  const { birthdayItems: eventsBirthdayItems } = useSelector((state) => state.events || {});
  const [birthdayReminderOpen, setBirthdayReminderOpen] = useState(false);

  useEffect(() => {
    if (canSeeEvents) {
      dispatch(fetchEmployeeBirthdayList());
    }
  }, [canSeeEvents, dispatch]);

  const EVENTS_ALLOWED_LOCATIONS = ["HAO", "ISM", "IIM"];
  const todaysBirthdays = useMemo(() => {
    if (!canSeeEvents || !eventsBirthdayItems || eventsBirthdayItems.length === 0) return [];
    const today = new Date();
    const todayDay = String(today.getDate()).padStart(2, "0");
    const todayMonth = today.toLocaleString("en-US", { month: "short" }).toUpperCase();
    return eventsBirthdayItems.filter((emp) => {
      if (!EVENTS_ALLOWED_LOCATIONS.includes(emp.EmployeeLocation) || emp.EmployeeStatus !== "A") return false;
      const parts = String(emp.EmployeeBirthday || "").split("-");
      return parts.length >= 2 && parts[0] === todayDay && parts[1]?.toUpperCase() === todayMonth;
    });
  }, [canSeeEvents, eventsBirthdayItems]);

  useEffect(() => {
    if (todaysBirthdays.length > 0) {
      setBirthdayReminderOpen(true);
    }
  }, [todaysBirthdays.length]);

  const subCat = String(employeeSubCategory || "").toUpperCase();

  const canAccess = (allowedCategories, allowedSubCategories = []) =>
    isFullAccessOverride ||
    allowedCategories.includes(String(employeeCategory || "").toUpperCase()) ||
    (subCat && allowedSubCategories.includes(subCat));

  const canSeeManagementInfo = canAccess(MENU_ACCESS.managementInfo, ["G"]);
  const canSeeIWORequest = canAccess(MENU_ACCESS.iwoRequest, ["G"]);
  const empCat = String(employeeCategory || "").trim().toUpperCase();
  const canSeeLeaveApproval = empCat === "S" || subCat === "G" || empCat === "D" || empCat === "E";

  const userLocation = String(role || "").trim().toUpperCase();
  const canSeeProductionMonitor = isFullAccessOverride || empCat === "D" || empCat === "E" || (userLocation === "HUC" && (empCat === "S" || subCat.trim() === "G"));
  const canSeeAttendanceSubmenu = canAccess(MANAGEMENT_SUBMENU_ACCESS.attendance, ["G"]);
  const canSeeEmployeesSubmenu = canAccess(MANAGEMENT_SUBMENU_ACCESS.employees);
  const canSeeProductionSubmenu = canAccess(MANAGEMENT_SUBMENU_ACCESS.production, ["G"]);

  // Base menu items
  const baseMenuItems = [
    ...(canSeeManagementInfo ? [{ text: "Management Info", path: "/overTimeView", icon: <OverTime /> }] : []),
    { text: "Home", path: "/home", icon: <HomeIcon /> },
    ...(canSeeEvents ? [{ text: "Events", path: "/events", icon: <CakeIcon /> }] : []),
    { text: "Today Attendance", path: "/todayAttendance", icon: <CalendarTodayIcon /> },
     ...(canSeeLeaveApproval ? [{ text: "Leave Approval", path: "/leaveApproval", icon: <LeaveApprovalIcon /> }] : []),
    ...(canSeeProductionMonitor ? [{ text: "Production Monitor", path: "/insertFrames", icon: <ProductionMonitorIcon /> }] : []),
    { text: "Attendance Jobs History", path: "/jobHistory", icon: <HistoryIcon /> },
    { text: "All Attendance Jobs History", path: "/jobHistoryAll", icon: <WorkHistoryIcon /> },
    // ...(canSeeIWORequest ? [{ text: "IWO Request", path: "/iwoRequest", icon: <IWO /> }] : []),
    { text: "Job", path: "/qrJobScanner", icon: <Job /> },
    { text: "Assign Jobs", path: "/assignJob", icon: <AssignmentIcon /> },
  ];

  // Conditional menu items
  const menuItems = [
    ...baseMenuItems,
    ...(jobValue && jobValue.length > 0
      ? [
          { text: "Assign OT", path: "/assignOT", icon: <OT /> },
          { text: "Holiday Assign OT", path: "/holidayOT", icon: <OT /> },
          { text: "OT Details", path: "/otDetails", icon: <ContentPasteIcon /> },
        ]
      : []),
    { text: "Log Out", path: "/logout", icon: <ExitToAppIcon /> },
  ];

  // Navigation handler
  const handleNavigation = (path) => {
    if (path === "/jobHistory" || path === "/jobHistoryAll") {
      dispatch(fetchJobItems(new Date().toISOString().split("T")[0], employeeId, role));
    }
    if (path === "/logout") {
      localStorage.clear();
      navigate("/");
    } else {
      navigate(path, { state: { employeeId, department, role } });
    }
    toggleDrawer(false);
  };

  // Clear all cache
  const handleClearCache = async () => {
    try {
      // 1. Clear localStorage
      localStorage.clear();

      // 2. Clear sessionStorage
      sessionStorage.clear();

      // 3. Clear service worker caches (PWA cache)
      if ("caches" in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map((name) => caches.delete(name)));
      }

      // 4. Unregister service workers
      if ("serviceWorker" in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((reg) => reg.unregister()));
      }

      setClearCacheDialogOpen(false);
      toggleDrawer(false);

      // Reload fresh after clearing
      window.location.href = "/";
    } catch (error) {
      console.error("Failed to clear cache:", error);
      setClearCacheDialogOpen(false);
    }
  };

  return (
    <>
      <Drawer
        open={open}
        onClose={() => toggleDrawer(false)}
        anchor="left"
        sx={{
          "& .MuiDrawer-paper": {
            width: 280,
            bgcolor: "transparent",
            borderRight: "none",
            transition: "transform 0.3s ease",
            transform: open ? "translateX(0)" : "translateX(-100%)",
            boxShadow: "0 0 15px rgba(0, 0, 0, 0.5)",
            borderTopRightRadius: 40,
            borderBottomRightRadius: 40,
            backdropFilter: "blur(10px)",
          },
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%", px: 2, py: 3, color: "white" }}>
          {/* Header */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
            <img src={Logo} alt="Logo" style={{ height: 70, objectFit: "contain", borderRadius: "5px" }} />
            <IconButton onClick={() => toggleDrawer(false)} sx={{ color: "white" }}>
              <CloseIcon />
            </IconButton>
          </Box>

          {/* User Info */}
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 2, textAlign: "center", width: "100%" }}>
            <Avatar
              src={userImg || "https://esystems.cdl.lk/QRApp_BackEnd/userImages/user.png"}
              onError={() => setUserImg("https://esystems.cdl.lk/QRApp_BackEnd/userImages/user.png")}
              sx={{ width: 130, height: 130, mb: 2, border: "3px solid #ddd" }}
            />
            <Typography variant="h6" color="white" sx={{ fontWeight: "bold" }}>
              {employeeName || "Loading..."}
            </Typography>
            <Typography variant="body2" sx={{ color: "#E0A300", mt: 1, fontWeight: "bold" }}>
              {department} - {role}
            </Typography>
          </Box>

          {/* Menu */}
          <List sx={{ mt: 4, flex: 1 }}>
            {menuItems.map((item) => {
              if (item.text === "Management Info") {
                return (
                  <Box key={item.text}>
                    <ListItem
                      button
                      onClick={() => setOpenManagement(!openManagement)}
                      sx={{ my: 1, borderRadius: 2, color: "white", "&:hover": { backgroundColor: "#F2B807" } }}
                    >
                      <ListItemAvatar>
                        <Avatar sx={{ backgroundColor: "transparent", color: "white" }}>{item.icon}</Avatar>
                      </ListItemAvatar>
                      <ListItemText primary={item.text} />
                      {openManagement ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={openManagement} timeout="auto" unmountOnExit>
                      {/* <List sx={{ pl: 6 }}>
                        <ListItem
                          button
                          onClick={() => handleNavigation("/overTimeView")}
                          sx={{ my: 0.5, borderRadius: 2, color: "white", transition: "all 0.3s ease", "&:hover": { backgroundColor: "#F2B807", transform: "scale(1.03)" } }}
                        >
                        <ListItemText primary="HR" />
                        </ListItem>
                        <ListItem
                          button
                          onClick={() => handleNavigation("/production")}
                          sx={{ my: 0.5, borderRadius: 2, color: "white", transition: "all 0.3s ease", "&:hover": { backgroundColor: "#F2B807", transform: "scale(1.03)" } }}
                        >
                          <ListItemText primary="Production" />
                        </ListItem>
                      </List> */}
                      <List sx={{ pl: 6 }}>
                        {canSeeAttendanceSubmenu && (
                          <ListItem
                            button
                            onClick={() => handleNavigation("/overTimeView")}
                            sx={{ my: 0.5, borderRadius: 2, color: "white", transition: "all 0.3s ease", "&:hover": { backgroundColor: "#F2B807", transform: "scale(1.03)" } }}
                          >
                          <ListItemText primary="Attendance" />
                          </ListItem>
                        )}
                        {canSeeEmployeesSubmenu && (
                          <ListItem
                            button
                            onClick={() => handleNavigation("/employees")}
                            sx={{ my: 0.5, borderRadius: 2, color: "white", transition: "all 0.3s ease", "&:hover": { backgroundColor: "#F2B807", transform: "scale(1.03)" } }}
                          >
                          <ListItemText primary="Employees" />
                          </ListItem>
                        )}
                        {canSeeProductionSubmenu && (
                          <ListItem
                            button
                            onClick={() => handleNavigation("/production")}
                            sx={{ my: 0.5, borderRadius: 2, color: "white", transition: "all 0.3s ease", "&:hover": { backgroundColor: "#F2B807", transform: "scale(1.03)" } }}
                          >
                            <ListItemText primary="Production" />
                          </ListItem>
                        )}
                      </List>
                    </Collapse>
                  </Box>
                );
              }

              // Production Monitor -> Insert Frames / Update Daily Remark
              if (item.text === "Production Monitor") {
                return (
                  <Box key={item.text}>
                    <ListItem
                      button
                      onClick={() => setOpenProductionMonitor(!openProductionMonitor)}
                      sx={{ my: 1, borderRadius: 2, color: "white", "&:hover": { backgroundColor: "#F2B807" } }}
                    >
                      <ListItemAvatar>
                        <Avatar sx={{ backgroundColor: "transparent", color: "white" }}>{item.icon}</Avatar>
                      </ListItemAvatar>
                      <ListItemText primary={item.text} />
                      {openProductionMonitor ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={openProductionMonitor} timeout="auto" unmountOnExit>
                      <List sx={{ pl: 6 }}>
                        {/* Pre Fabrication */}
                        <ListItem
                          button
                          onClick={() => setOpenPreFab(!openPreFab)}
                          sx={{ my: 0.5, borderRadius: 2, color: "white", "&:hover": { backgroundColor: "#F2B807" } }}
                        >
                          <ListItemText primary="Pre Fabrication" />
                          {openPreFab ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                        <Collapse in={openPreFab} timeout="auto" unmountOnExit>
                          <List sx={{ pl: 3 }}>
                            <ListItem
                              button
                              onClick={() => handleNavigation("/insertFrames")}
                              sx={{ my: 0.5, borderRadius: 2, color: "white", transition: "all 0.3s ease", "&:hover": { backgroundColor: "#F2B807", transform: "scale(1.03)" } }}
                            >
                              <ListItemText primary="Insert Frames" />
                            </ListItem>
                            <ListItem
                              button
                              onClick={() => handleNavigation("/dailyRemark")}
                              sx={{ my: 0.5, borderRadius: 2, color: "white", transition: "all 0.3s ease", "&:hover": { backgroundColor: "#F2B807", transform: "scale(1.03)" } }}
                            >
                              <ListItemText primary="Update Daily Remark" />
                            </ListItem>
                          </List>
                        </Collapse>

                        {/* Erection */}
                        <ListItem
                          button
                          onClick={() => setOpenErection(!openErection)}
                          sx={{ my: 0.5, borderRadius: 2, color: "white", "&:hover": { backgroundColor: "#F2B807" } }}
                        >
                          <ListItemText primary="Erection" />
                          {openErection ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                        <Collapse in={openErection} timeout="auto" unmountOnExit>
                          <List sx={{ pl: 3 }}>
                            <ListItem
                              button
                              onClick={() => handleNavigation("/insertTargetDates")}
                              sx={{ my: 0.5, borderRadius: 2, color: "white", transition: "all 0.3s ease", "&:hover": { backgroundColor: "#F2B807", transform: "scale(1.03)" } }}
                            >
                              <ListItemText primary="Insert Target Dates" />
                            </ListItem>
                            <ListItem
                              button
                              onClick={() => handleNavigation("/erectionDailyRemark")}
                              sx={{ my: 0.5, borderRadius: 2, color: "white", transition: "all 0.3s ease", "&:hover": { backgroundColor: "#F2B807", transform: "scale(1.03)" } }}
                            >
                              <ListItemText primary="Update Daily Remark" />
                            </ListItem>
                          </List>
                        </Collapse>
                      </List>
                    </Collapse>
                  </Box>
                );
              }

              // Regular menu item
              return (
                <ListItem
                  button
                  key={item.text}
                  onClick={() => handleNavigation(item.path)}
                  sx={{
                    my: 1,
                    backgroundColor: item.path === window.location.pathname ? "#E0A300" : "transparent",
                    color: "white",
                    borderRadius: 2,
                    fontWeight: "bold",
                    fontSize: 18,
                    transition: "all 0.3s ease",
                    "&:hover": { backgroundColor: "#F2B807", transform: "scale(1.05)" },
                  }}
                >
                  <ListItemAvatar>
                    {item.text === "Events" && todaysBirthdays.length > 0 ? (
                      <Badge
                        color="error"
                        variant="dot"
                        overlap="circular"
                        sx={{ "& .MuiBadge-dot": { boxShadow: "0 0 0 2px #142c54" } }}
                      >
                        <Avatar sx={{ backgroundColor: "transparent", color: "white" }}>{item.icon}</Avatar>
                      </Badge>
                    ) : (
                      <Avatar sx={{ backgroundColor: "transparent", color: "white" }}>{item.icon}</Avatar>
                    )}
                  </ListItemAvatar>
                  <ListItemText primary={item.text} />
                </ListItem>
              );
            })}
          </List>

          {/* Clear Cache Button — pinned at bottom */}
          <Box sx={{ pb: 2, px: 1 }}>
            <ListItem
              button
              onClick={() => setClearCacheDialogOpen(true)}
              sx={{
                borderRadius: 2,
                color: "white",
                border: "1px solid rgba(255,255,255,0.25)",
                backgroundColor: "rgba(255,255,255,0.07)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(220, 53, 69, 0.6)",
                  transform: "scale(1.03)",
                  border: "1px solid rgba(220,53,69,0.8)",
                },
              }}
            >
              <ListItemAvatar>
                <Avatar sx={{ backgroundColor: "transparent", color: "white" }}>
                  <DeleteSweepIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary="Clear Cache"
                secondary="Refresh app data"
                primaryTypographyProps={{ fontWeight: "bold", color: "white", fontSize: 14 }}
                secondaryTypographyProps={{ color: "rgba(255,255,255,0.6)", fontSize: 11 }}
              />
            </ListItem>
          </Box>
        </Box>
      </Drawer>

      {/* Confirmation Dialog */}
      <Dialog
        open={clearCacheDialogOpen}
        onClose={() => setClearCacheDialogOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 1,
            boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 700, color: "#1e3c72", display: "flex", alignItems: "center", gap: 1 }}>
          <DeleteSweepIcon sx={{ color: "#dc3545" }} />
          Clear App Cache?
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: "#555" }}>
            This will clear all locally stored data, cached files, and service workers. The app will reload and you will need to log in again.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
          <Button
            onClick={() => setClearCacheDialogOpen(false)}
            variant="outlined"
            sx={{ borderRadius: 2, textTransform: "none", borderColor: "#ccc", color: "#555" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleClearCache}
            variant="contained"
            sx={{
              borderRadius: 2,
              textTransform: "none",
              backgroundColor: "#dc3545",
              "&:hover": { backgroundColor: "#b02a37" },
            }}
          >
            Yes, Clear Cache
          </Button>
        </DialogActions>
      </Dialog>

      {/* Birthday reminder — access users only */}
      <Snackbar
        open={birthdayReminderOpen}
        autoHideDuration={7000}
        onClose={() => setBirthdayReminderOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{ mt: 6 }}
      >
        <Alert
          onClose={() => setBirthdayReminderOpen(false)}
          severity="warning"
          variant="filled"
          icon={<CakeIcon fontSize="inherit" />}
          sx={{
            backgroundColor: "#E0A300",
            color: "#142c54",
            fontWeight: 600,
            "& .MuiAlert-icon": { color: "#142c54" },
          }}
        >
          {todaysBirthdays.length === 1
            ? `It's ${todaysBirthdays[0].EmployeeName}'s birthday today!`
            : todaysBirthdays.length > 1
            ? `${todaysBirthdays.length} birthdays today: ${todaysBirthdays.map((e) => e.EmployeeName).join(", ")}`
            : ""}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Sidebar;